exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".label {\n    margin-bottom: var(--spacing-half);\n}\n\n.label.has-error {\n    color: var(--color-red-500);\n}\n\n.label .text,\n.label .error {\n    color: inherit;\n}\n\n.label .tooltip {\n    margin-left: var(--spacing-half);\n}\n\n.label .tooltip i {\n    vertical-align: inherit;\n}\n\n.label .tooltip i:hover {\n    cursor: pointer;\n}\n", ""]);

// exports
